export type SeafoodCategory = "Fish" | "Shellfish" | "Premium";

export const SEAFOOD_CATEGORIES: SeafoodCategory[] = ["Fish", "Shellfish", "Premium"];

export interface SeafoodItem {
  id: string;
  name: string;
  /** The species' scientific (Latin) name, matching the credited photograph. */
  scientificName: string;
  category: SeafoodCategory;
  description: string;
  price: string;
  unit: string;
  tags: string[];
  hue: "teal" | "coral" | "ocean";
  image: string;
  credit: string;
}

export const seafoodItems: SeafoodItem[] = [
  {
    id: "vanjaram-kingfish",
    name: "Vanjaram Kingfish",
    scientificName: "Scomberomorus commerson",
    category: "Fish",
    description: "Firm, meaty steaks — the king of South Indian fish curries.",
    price: "₹850",
    unit: "per kg",
    tags: ["Wild-Caught", "Best Seller"],
    hue: "teal",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Narrow-barred_spanish_mackerel_%28Scomberomorus_commerson%29.jpg/960px-Narrow-barred_spanish_mackerel_%28Scomberomorus_commerson%29.jpg",
    credit: "Rickard Zerpe / Wikimedia Commons, CC BY 2.0",
  },
  {
    id: "karimeen-pearlspot",
    name: "Karimeen (Pearl Spot)",
    scientificName: "Etroplus suratensis",
    category: "Fish",
    description: "Kerala backwater specialty, prized pan-fried in banana leaf.",
    price: "₹650",
    unit: "per kg",
    tags: ["Wild-Caught", "Kerala Special"],
    hue: "ocean",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Green_chromide_5096.jpg/960px-Green_chromide_5096.jpg",
    credit: "Vengolis / Wikimedia Commons, CC BY-SA 4.0",
  },
  {
    id: "tiger-prawns",
    name: "Tiger Prawns (Jhinga)",
    scientificName: "Penaeus monodon",
    category: "Shellfish",
    description: "Large, sweet prawns hand-sorted at the harbor.",
    price: "₹600",
    unit: "per kg",
    tags: ["Wild-Caught"],
    hue: "coral",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Penaeus_monodon.jpg/960px-Penaeus_monodon.jpg",
    credit: "Wikimedia Commons, CC BY-SA 3.0",
  },
  {
    id: "mud-crab",
    name: "Mud Crab (Nandu)",
    scientificName: "Scylla serrata",
    category: "Shellfish",
    description: "Meaty mangrove crab, a Chettinad favorite.",
    price: "₹550",
    unit: "per kg",
    tags: ["Sustainable"],
    hue: "teal",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Scylla_serrata_by_OpenCage.jpg/960px-Scylla_serrata_by_OpenCage.jpg",
    credit: "OpenCage / Wikimedia Commons, CC BY-SA 2.5",
  },
  {
    id: "silver-pomfret",
    name: "Silver Pomfret (Paplet)",
    scientificName: "Pampus argenteus",
    category: "Fish",
    description: "Delicate white flesh, perfect for a classic coastal fish fry.",
    price: "₹780",
    unit: "per kg",
    tags: ["Wild-Caught", "Best Seller"],
    hue: "ocean",
    image: "https://upload.wikimedia.org/wikipedia/commons/4/48/Silver_Pomfret_%28Pampus_argenteus%29.jpg",
    credit: "Kavana V Nayak / Wikimedia Commons, CC BY-SA 4.0",
  },
  {
    id: "indian-mackerel",
    name: "Indian Mackerel (Bangda)",
    scientificName: "Rastrelliger kanagurta",
    category: "Fish",
    description: "Everyday favorite, rich and oily — classic coastal comfort food.",
    price: "₹240",
    unit: "per kg",
    tags: ["Wild-Caught", "Everyday Value"],
    hue: "coral",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Rastrelliger_kanagurta.jpg/960px-Rastrelliger_kanagurta.jpg",
    credit: "Rob / Wikimedia Commons, CC BY 2.0",
  },
  {
    id: "squid",
    name: "Squid (Koonthal)",
    scientificName: "Uroteuthis duvaucelii",
    category: "Shellfish",
    description: "Tender, fresh-cleaned squid — rings and tubes, ready to cook.",
    price: "₹480",
    unit: "per kg",
    tags: ["Fresh Catch"],
    hue: "ocean",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/Uroteuthis_duvaucelii_122342233.jpg/960px-Uroteuthis_duvaucelii_122342233.jpg",
    credit: "Wikimedia Commons, CC BY 4.0",
  },
  {
    id: "spiny-lobster",
    name: "Malabar Spiny Lobster",
    scientificName: "Panulirus homarus",
    category: "Premium",
    description: "Prized Kerala coast catch, sweet and succulent.",
    price: "₹2,200",
    unit: "per kg",
    tags: ["Limited", "Premium"],
    hue: "coral",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Panulirus_homarus_130.jpg/960px-Panulirus_homarus_130.jpg",
    credit: "Vengolis / Wikimedia Commons, CC BY-SA 3.0",
  },
  {
    id: "red-snapper",
    name: "Red Snapper (Sankara)",
    scientificName: "Lutjanus argentimaculatus",
    category: "Premium",
    description: "Firm and delicately sweet — a favorite at coastal restaurants.",
    price: "₹680",
    unit: "per kg",
    tags: ["Premium"],
    hue: "teal",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Mangrove_Red_Snapper_Lutjanus_argentimaculatus_01.jpg/960px-Mangrove_Red_Snapper_Lutjanus_argentimaculatus_01.jpg",
    credit: "Dr. Raju Kasambe / Wikimedia Commons, CC BY-SA 4.0",
  },
];
